import { useState } from 'react'
import { Box, IconButton } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useTranslation } from 'react-i18next'
import { getProxiedImageUrl } from '@aperture/ui'

interface MediaBackdropProps {
  backdropUrl: string | null
  title: string
  onBack: () => void
}

export function MediaBackdrop({ backdropUrl, title, onBack }: MediaBackdropProps) {
  const { t } = useTranslation()
  const [imageError, setImageError] = useState(false)
  const proxiedBackdropUrl = backdropUrl ? getProxiedImageUrl(backdropUrl, '') : null

  return (
    <Box
      sx={{
        position: 'relative',
        height: { xs: 250, md: 350 },
        mx: -3,
        mt: -3,
        mb: 0,
        overflow: 'hidden',
      }}
    >
      {proxiedBackdropUrl && !imageError ? (
        <Box
          component="img"
          src={proxiedBackdropUrl}
          alt={title}
          onError={() => setImageError(true)}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            filter: 'brightness(0.6)',
          }}
        />
      ) : (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            background: 'var(--ap-backdrop-fallback, linear-gradient(135deg, #1a1a2e 0%, #16213e 100%))',
          }}
        />
      )}

      {/* Gradient overlay */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '60%',
          background: 'var(--ap-backdrop-fade, linear-gradient(to top, rgba(18,18,18,1) 0%, rgba(18,18,18,0) 100%))',
        }}
      />

      {/* Back button */}
      <IconButton
        onClick={onBack}
        aria-label={t('common.back')}
        sx={{
          position: 'absolute',
          top: 16,
          left: 16,
          bgcolor: 'rgba(0,0,0,0.5)',
          color: 'white',
          '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' },
        }}
      >
        <ArrowBackIcon />
      </IconButton>
    </Box>
  )
}

